// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"i+2Lv","btn":"zxu+u","google":"H8Je4","apple":"pm78V","btn-content":"z014J","pseudoApple":"sDlzs"};